import {
  BrowserAuthError,
  BrowserAuthErrorCodes,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useRef } from "react";

import { useLogout } from "~/hooks/useLogout";
import { DEFAULT_SCOPES, SILENT_REDIRECT_URI } from "~/lib/auth";

export function useAcquireToken() {
  const logout = useLogout();

  const {
    instance: msal,
    accounts: [account],
  } = useMsal();

  const state = useRef({
    msal,
    account,
    logout,
  });

  useEffect(() => {
    state.current = {
      msal,
      account,
      logout,
    };
  }, [msal, account, logout]);

  return useCallback(async function acquireToken(scopes = DEFAULT_SCOPES) {
    try {
      return await state.current.msal.acquireTokenSilent({
        account: state.current.account,
        scopes,
        redirectUri: SILENT_REDIRECT_URI,
      });
    } catch (error) {
      // A stale session surfaces either as InteractionRequiredAuthError or,
      // when the silent-iframe SSO flow can't complete (e.g. Firefox Total
      // Cookie Protection / Chrome third-party cookie blocking prevents the
      // prompt=none iframe from returning a hash), as a "timed_out"
      // BrowserAuthError. Both mean the user must sign in again.
      const needsReauth =
        error instanceof InteractionRequiredAuthError ||
        (error instanceof BrowserAuthError &&
          error.errorCode === BrowserAuthErrorCodes.timedOut);
      if (needsReauth) {
        await state.current.logout();
      }
      throw error;
    }
  }, []);
}
